
import LogoIcon from '@src/assets/icons/logo-icon.svg';
import pageSlugs from '@src/components/layout/pageSlugs';
import { Link } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Container, Flex } from 'theme-ui';
import { Themed } from '@theme-ui/mdx';

const Error404Page = ({ pageLocale }) => {
  const { t, i18n } = useTranslation();

  return (
    <Box mt={6} sx={{ backgroundColor: '#F2F6FF' }}>
      <Container py={6} px={4}>
        <Flex
          sx={{
            alignItems: 'center',
            gap: '60px',
            flexDirection: ['column-reverse', null, null, 'row'],
          }}
        >
          <Box>
            <Themed.h1>{t('404title')}</Themed.h1>
            <Box>
              <Link to={`/${pageSlugs.homePage[pageLocale]}`}>
                <Button>{t('goHome')}</Button>
              </Link>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: [5, null, null, 0],
              marginLeft: 'auto',
              marginRight: ['auto', null, null, '0'],
              width: ['100%', null, null, '560px'],
              position: 'relative',
              textAlign: 'center',
            }}
          >
            <Box
              sx={{
                color: 'primary',
                position: 'absolute',
                zIndex: 0,
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
              }}
            >
              <LogoIcon
                sx={{
                  opacity: '0.5',
                  width: '100%',
                  height: '100%',
                }}
              />
            </Box>
            <Themed.p
              sx={{
                position: 'relative',
                fontSize: ['60px', null, null, '180px'],
                paddingBottom: 5,
              }}
            >
              404
            </Themed.p>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};

export default Error404Page;
